export enum TaskStatus {
  ENABLED = "ENABLED",
  DISABLED = "DISABLED",
  DELETED = "DELETED",
}

export type TaskType = {
  id: string;
  status: "ENABLED" | "DISABLED" | "DELETED";
  name: string;
  user_id: string;
  chat_session_id: string;
  user_query: string;
  cron: string;
  cadence: Frequency;
  timezone: string;
  should_send_email: boolean;
  by_minute: number;
  by_hour: number;
  by_week_day: number;
  by_month: number | null;
  by_month_day: number | null;
  by_year: number | null;
  by_scheduled_time: string | null;
  created_at: string;
  updated_at: string | null;
  deleted_at: string | null;
  disabled_at: string | null;
};

export const taskLimitByPlan = {
  Free: 3,
  Pro: 10,
  Premium: 10,
};

export enum Frequency {
  ONCE = "ONCE",
  DAILY = "DAILY",
  WEEKLY = "WEEKLY",
  MONTHLY = "MONTHLY",
}

export enum WarningModalType {
  DELETE = "DELETE",
  PREVIEW = "PREVIEW",
  UNSAVED = "UNSAVED",
}
export const frequencyOptions = [
  { label: "Once", value: Frequency.ONCE },
  { label: "Daily", value: Frequency.DAILY },
  { label: "Weekly", value: Frequency.WEEKLY },
  { label: "Monthly", value: Frequency.MONTHLY },
];

export const weekdayMap = {
  1: "Sunday",
  2: "Monday",
  3: "Tuesday",
  4: "Wednesday",
  5: "Thursday",
  6: "Friday",
  7: "Saturday",
};
